<template>
  <div>
    <validation-observer ref="form">
      <div class="row">
        <div class="col-12 col-md-3">
          <label class="data-label">Correo Electrónico:</label>
          <p v-if="isReadOnly">{{ model.email }}</p>
          <ValidationProvider
            v-else
            v-slot="{ errors }"
            name="email"
            rules="required|email"
            :custom-messages="{
              required: 'El campo Correo Electrónico es requerido',
              email: 'Favor de entrar un correo electrónico válido.'
            }"
          >
            <CustomInput
              id="txtContactEmail"
              v-model="model.email"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-md-3">
          <label class="data-label"
            >Fecha en que se discute el documento en COMPU:</label
          >
          <p v-if="isReadOnly">{{ model.dateDiscussion | date }}</p>
          <ValidationProvider
            v-else
            v-slot="{ errors }"
            name="date"
            rules="required"
          >
            <custom-date-picker
              v-model="model.dateDiscussion"
              required
              placeholder="DD/MM/YYYY"
              :max-date="maxDate"
              :error="errors[0]"
              custom-error-msg="La fecha de discusión es requerida."
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-md-3">
          <label class="data-label">Diploma que recibe:</label>
          <p>{{ data.diploma }}</p>
        </div>
        <div class="col-12 col-md-3">
          <label class="data-label">Lenguaje principal:</label>
          <p v-if="isReadOnly">{{ model.language?.name }}</p>
          <validation-provider
            v-else
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              id="forAdmission"
              v-model="model.language"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :error="errors[0]"
              custom-error-msg="Favor seleccionar un lenguaje principal."
              :options="data.languages"
              :disabled="isReadOnly"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="py-4 d-flex justify-content-end">
      <action-button
        type="button"
        text="Continuar"
        i="fas fa-arrow-alt-circle-right"
        variant="success"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import CustomInput from "CustomInput";
import CustomDatePicker from "custom-date-picker";
import CustomDropDown from "custom-drop-down";
export default {
  name: "StudentInfo",
  components: {
    ActionButton,
    CustomInput,
    CustomDatePicker,
    CustomDropDown
  },
  props: {
    data: {
      type: Object,
      dafault: () => ({})
    },
    value: {
      type: Object,
      dafault: () => ({})
    },
    isReadOnly: {
      type: Boolean,
      dafault: () => false
    }
  },
  data: () => ({
    maxDate: new Date()
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    async validate() {
      const valid = await this.$refs.form.validate();
      return { valid, message: valid ? "" : "Todos lo campos son requeridos" };
    },
    next() {
      this.$emit("next", this.value);
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler() {
        Object.assign(this.model, this.data);
        if (this.model.languages) delete this.model.languages;
        this.model.language = this.data.languages?.find(
          x => x.id === this.data.languageId
        );
      }
    }
  }
};
</script>
<style scoped lang="scss">
::v-deep .custom-datetime-picker-container.width-container {
  width: 100% !important;
}
</style>
